import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

// ... existing imports ...

const tabData = [
   {
      id: '01ete',
      title: '01. Custom Healthcare Software Development',
      intitle: 'Custom Healthcare Software Development',
      icon: '/assets/svg/industries/HealthFitness/01.svg',
      content:
         'We provide personalized healthcare software to improve patient care, automate work processes, and optimize operational efficiency. Our offerings encompass customized EHRs, patient management systems, and medical applications, with assured secure data management and regulatory compliance. With scalability and ease of use at the forefront, we develop solid platforms that equip healthcare professionals to deliver quality care and maximize resource management.',
   },
   {
      id: '02ete',
      title: '02. HIPAA-Compliant Software Development',
      intitle: 'HIPAA-Compliant Software Development',
      icon: '/assets/svg/industries/HealthFitness/02.svg',
      content:
         'We specialize in developing HIPAA-compliant health software that promises secure management of sensitive patient information. Our offering includes EHR systems, patient portals, telehealth platforms, and mobile health apps with end-to-end encryption, access controls, and safe data storage. By strictly adhering to the HIPAA requirements, we empower healthcare providers with patient privacy safeguards, regulatory compliances, and reliable digital health solutions.',
   },
   {
      id: '03ete',
      title: '03. Modernizing Healthcare Systems',
      intitle: 'Modernizing Healthcare Systems',
      icon: '/assets/svg/industries/HealthFitness/03.svg',
      content:
         'We transform outdated healthcare systems with modern technologies, boosting efficiency and security. Our group modernizes antiquated platforms with rich features such as cloud integration, data automation, and AI-fueled insights. By elevating performance, compliance, and future-proof operations, we position healthcare organizations competitively while enhancing patient experiences and providing quality medical services.',
   },
   {
      id: '04ete',
      title: '04. Seamless Healthcare Software Integration',
      intitle: 'Seamless Healthcare Software Integration',
      icon: '/assets/svg/industries/HealthFitness/04.svg',
      content:
         'We harmonize healthcare systems for better data quality, reduced duplication of efforts, and eliminations of redundancy. Our specialists interconnect EHRs, patient portals, billings software, and third-party applications with ensured data flows and interoperability. By allowing instantaneous access to real-time data, eliminating much manual work, and automating decisions, we elevate patient care, enhance decision making, and facilitate overall efficiency of healthcare.',
   },
   {
      id: '05ete',
      title: '05. Custom Healthcare Product Development',
      intitle: 'Custom Healthcare Product Development',
      icon: '/assets/svg/industries/HealthFitness/05.svg',
      content:
         'We create custom healthcare solutions from idea to launch, meeting distinctive industry requirements. Our developers build innovative medical applications, diagnostic instruments, and patient engagement platforms with intuitive UI/UX, regulatory compliance, and data security. Through scalable, user-driven products, we enable healthcare professionals to improve service delivery and promote improved patient outcomes.',
   },
   {
      id: '06ete',
      title: '06. AI-Powered Healthcare Services',
      intitle: 'AI-Powered Healthcare Services',
      icon: '/assets/svg/industries/HealthFitness/06.svg',
      content:
         'We craft custom healthcare solutions from design to market, meeting specific industry requirements. We design engaging medical applications, diagnostic solutions, and patient engagement platforms with intuitive UI/UX, regulatory approvals, and data protection. Through the delivery of scalable, user-focused solutions, we enable healthcare providers to improve service delivery and achieve improved patient outcomes.',
   },
]

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Cutting-Edge Health & Fitness Software Development Services
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Being a top health & fitness software development firm, we design bespoke, AI-powered, and data-focused wellness solutions that empower people, gyms, trainers, and healthcare professionals. Our user-friendly and scalable applications provide greater user engagement, real-time tracking of health, and effortless management of fitness. Explore our comprehensive health & fitness software development services:
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
